import React from "react";
// Common Components
import {
  DynamicDropdown,
  Button,
  TextInput,
  DynamicMultiSelectDropdown,
} from "src/Components";
// Request
import {
  getBourseKalaInstrument,
  getDueDateMonths,
  getGroupInstrument,
  getPairType,
  getFirstSide,
  getSecondSide,
} from "src/Requests/iMEMarketWatch";
// Types
import type { IPairPositionSearchParams } from "src/Interfaces/iMEMarketWatch";

interface IProps {
  searchParamChangeHandler: (name: string, value: any) => void;
  searchParam: IPairPositionSearchParams;
  onSubmit: () => void;
}

const PairPositionSearchParamUI: React.FC<IProps> = ({
  searchParam,
  searchParamChangeHandler,
  onSubmit,
}) => (
  <div>
    <div className="border border-gray-300 rounded p-3 flex flex-col gap-3 !w-[350px] !min-w-[350px]">
      <div className="flex flex-row justify-start items-start gap-3 w-full">
        <div className="w-full">
          <DynamicDropdown
            dropdown={{
              name: "groupId",
              placeholder: "گروه",
              extraLabel: true,
            }}
            getData={() => getGroupInstrument()}
            onChange={searchParamChangeHandler}
            value={searchParam?.groupId}
          />
        </div>
        <div className="w-full">
          <DynamicMultiSelectDropdown
            dropdown={{
              name: "baseInsIds",
              placeholder: "نماد پایه",
              extraLabel: true,
            }}
            getData={() => getBourseKalaInstrument()}
            onChange={searchParamChangeHandler}
            value={searchParam?.baseInsIds}
          />
        </div>
      </div>
      <div className="flex flex-row justify-start items-start gap-3 w-full">
        <div className="w-full">
          <DynamicMultiSelectDropdown
            dropdown={{
              name: "pairPositionTypeIds",
              placeholder: "نوع جفت",
              extraLabel: true,
            }}
            getData={getPairType}
            onChange={searchParamChangeHandler}
            value={searchParam?.pairPositionTypeIds}
          />
        </div>
        <div className="w-full">
          <DynamicDropdown
            dropdown={{
              name: "lastTradingMonthType",
              placeholder: "مقایسه ماه سررسید",
              extraLabel: true,
            }}
            getData={() => getDueDateMonths()}
            onChange={searchParamChangeHandler}
            value={searchParam?.lastTradingMonthType?.toString() || ""}
          />
        </div>
      </div>

      <div className="flex flex-row justify-start items-start gap-3 w-full">
        <div className="w-full">
          <DynamicDropdown
            dropdown={{
              name: "insId1",
              placeholder: "نماد سمت خرید",
              extraLabel: true,
            }}
            getData={getFirstSide}
            onChange={searchParamChangeHandler}
            value={searchParam?.insId1?.toString() || ""}
          />
        </div>
        <div className="w-full">
          <DynamicDropdown
            dropdown={{
              name: "insId2",
              placeholder: "نماد سمت فروش",
              extraLabel: true,
            }}
            getData={getSecondSide}
            onChange={searchParamChangeHandler}
            value={searchParam?.insId2?.toString() || ""}
          />
        </div>
      </div>
      <div className="flex flex-row justify-start items-start gap-3 w-full">
        <div className="w-full">
          <TextInput
            name="minYesterdayVolume"
            label="حداقل حجم معاملات روز قبل"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.minYesterdayVolume?.toString() || ""}
            kind="price"
          />
        </div>
        <div className="w-full">
          <TextInput
            name="minYearlyGain"
            label="حداقل ٪ بازده مرکب سالانه"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.minYearlyGain?.toString() || ""}
          />
        </div>
      </div>
      <div className="flex flex-row justify-start items-start gap-3 w-full">
        <TextInput
          name="minDistanceToBreakEvenPoint"
          label="حداقل ٪ فاصله تا نقطه سر به سر"
          extraLabel
          onChange={searchParamChangeHandler}
          value={searchParam?.minDistanceToBreakEvenPoint?.toString() || ""}
          kind="negativeDecimalNumbers"
        />
      </div>
      <div className="flex flex-row justify-start items-start gap-3 w-full">
        <div className="w-full">
          <TextInput
            name="minITM1"
            label="حداقل درصد ITM اول"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.minITM1?.toString() || ""}
            kind="negativeDecimalNumbers"
          />
        </div>
        <div className="w-full">
          <TextInput
            name="minITM2"
            label="حداقل درصد ITM دوم"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.minITM2?.toString() || ""}
            kind="negativeDecimalNumbers"
          />
        </div>
      </div>
      <div className="flex flex-row justify-start items-start gap-3 w-full">
        <div className="w-full">
          <TextInput
            name="minDTM1"
            label="حداقل DTM اول"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.minDTM1?.toString() || ""}
          />
        </div>
        <div className="w-full">
          <TextInput
            name="maxDTM1"
            label="حداکثر DTM اول"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.maxDTM1?.toString() || ""}
          />
        </div>
      </div>
      <div className="flex flex-row justify-start items-start gap-3 w-full">
        <div className="w-full">
          <TextInput
            name="minDTM2"
            label="حداقل DTM دوم"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.minDTM2?.toString() || ""}
          />
        </div>
        <div className="w-full">
          <TextInput
            name="maxDTM2"
            label="حداکثر DTM دوم"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.maxDTM2?.toString() || ""}
          />
        </div>
      </div>
      <Button onClick={onSubmit} text="جستجو" variant="contained" />
    </div>
  </div>
);

export default PairPositionSearchParamUI;
